module.exports = __webpack_public_path__ + "img/pd-img1.d29ba9ff.png";